<template>
  <b-card title="مدیریت تگ‌های نمایشی">
    <p>تگ‌ها را بسازید و سپس در فرم ایجاد یا ویرایش دوره و بلاگ انتخاب کنید. تغییر عنوان تگ در همه موارد متصل به آن نمایش داده می‌شود.</p>
    <b-alert :show="Boolean(error)" variant="danger">{{ error }}</b-alert>
    <b-alert :show="Boolean(message)" variant="success">{{ message }}</b-alert>
    <b-form @submit.prevent="save">
      <b-form-group :label="editingId ? 'ویرایش عنوان تگ' : 'عنوان تگ جدید'" label-for="tag-title">
        <b-form-input id="tag-title" v-model="title" maxlength="100" :disabled="busy" required />
      </b-form-group>
      <b-button type="submit" variant="primary" :disabled="busy || !title.trim()">{{ editingId ? 'ذخیره تغییرات' : 'ایجاد تگ' }}</b-button>
      <b-button v-if="editingId" class="ml-1" variant="outline-secondary" :disabled="busy" @click="resetForm">انصراف</b-button>
    </b-form>
    <b-form-group class="mt-2" label="جستجوی تگ" label-for="tag-search">
      <b-form-input id="tag-search" v-model="search" placeholder="جستجو بر اساس عنوان" />
    </b-form-group>
    <b-table :items="filteredTags" :fields="fields" :busy="busy" primary-key="tagId" responsive show-empty empty-text="تگی ثبت نشده است.">
      <template #cell(actions)="{ item }">
        <b-button size="sm" variant="outline-primary" :disabled="busy" @click="edit(item)">ویرایش</b-button>
        <b-button size="sm" variant="outline-danger" class="ml-1" :disabled="busy" @click="remove(item)">حذف</b-button>
      </template>
    </b-table>
    <b-button variant="outline-secondary" :disabled="busy" @click="loadTags">بازخوانی فهرست</b-button>
  </b-card>
</template>

<script>
import { BAlert, BButton, BCard, BForm, BFormGroup, BFormInput, BTable } from 'bootstrap-vue'
import { tagRequest } from '@/libs/Api/Tag'

export default {
  title: 'مدیریت تگ‌ها - پنل ادمین بنفشه باقری',
  components: { BAlert, BButton, BCard, BForm, BFormGroup, BFormInput, BTable },
  data() {
    return {
      tags: [], title: '', editingId: null, search: '', busy: false, error: '', message: '',
      fields: [{ key: 'title', label: 'عنوان' }, { key: 'actions', label: 'عملیات' }],
    }
  },
  computed: {
    filteredTags() { return this.tags.filter(tag => tag.title.includes(this.search.trim())) },
  },
  created() { this.loadTags() },
  methods: {
    resetForm() { this.title = ''; this.editingId = null },
    edit(tag) { this.title = tag.title; this.editingId = tag.tagId; this.message = '' },
    async loadTags() {
      this.busy = true
      this.error = ''
      try { this.tags = await tagRequest(this, 'GetAll') }
      catch (error) { this.error = error.message || 'دریافت فهرست انجام نشد.' }
      finally { this.busy = false }
    },
    async save() {
      if (this.busy || !this.title.trim()) return
      this.busy = true
      this.error = ''
      this.message = ''
      try {
        await tagRequest(this, this.editingId ? 'Update' : 'Create', { tagId: this.editingId || 0, title: this.title.trim() })
        this.resetForm()
        this.message = 'تگ ذخیره شد.'
        this.tags = await tagRequest(this, 'GetAll')
      } catch (error) { this.error = error.message || 'ذخیره تگ انجام نشد.' }
      finally { this.busy = false }
    },
    async remove(tag) {
      const confirmed = await this.$bvModal.msgBoxConfirm(`تگ «${tag.title}» حذف شود؟ این تگ از نمایش تمام دوره‌ها، اسلایدرها و بلاگ‌های مرتبط حذف می‌شود.`, {
        title: 'حذف تگ', okTitle: 'حذف', cancelTitle: 'انصراف', okVariant: 'danger', centered: true,
      })
      if (!confirmed) return
      this.busy = true
      this.error = ''
      this.message = ''
      try {
        await tagRequest(this, 'Delete', { tagId: tag.tagId })
        this.tags = this.tags.filter(item => item.tagId !== tag.tagId)
        if (this.editingId === tag.tagId) this.resetForm()
        this.message = 'تگ حذف شد.'
      } catch (error) { this.error = error.message || 'حذف تگ انجام نشد.' }
      finally { this.busy = false }
    },
  },
}
</script>
